import React from "react";
// import sections
import Hero from "../components/sections/Hero";
import FeaturesTiles from "../components/sections/FeaturesTiles";
import FeaturesSplit from "../components/sections/FeaturesSplit";
import Cta from "../components/sections/Cta";
import ParallaxSection from "../components/sections/ParallaxSection";
const Home = () => {
  return (
    <>
      <Hero className="illustration-section-01" />
      <a id="about"></a>
      <FeaturesTiles />
      <a id="work"></a>
      <FeaturesSplit
        invertMobile
        topDivider
        imageFill
        className="illustration-section-02"
      />
      <ParallaxSection />
      <a id="contact"></a>
      <Cta split />
    </>
  );
};

export default Home;
